import { fromJS } from 'immutable';
import { createReducer } from 'redux-act';
import { loop, Effects } from 'redux-loop';
import createActions from 'modules/create-actions';
import { request } from 'modules/request';
import ErrorStates from './lib/errorStates';
import camelize from './lib/camelize';

export const initialState = fromJS({
  isOpen: false,
  lineItems: [],
  isLoading: false,
  errorMessage: null,
  errorState: ErrorStates.NONE,
  addFailureBrandName: null,
});

export const Actions = createActions('CartDropdown', [
  'open', 'close', 'toggle', 'loadLineItemsStart',
  'loadLineItemsSuccess', 'loadLineItemsFailure',
  'removeLineItemStart', 'removeLineItemSuccess',
  'removeLineItemFailure', 'addLineItemFailure',
]);

export const Api = {
  loadLineItems() {
    return request({
      url: '/cart/widget.json',
      method: 'GET',
      protectCSRF: true,
      abortTag: Symbol('cartDropdown::loadLineItems'),
    })
    .then(camelize)
    .then(Actions.loadLineItemsSuccess)
    .catch(() => Actions.loadLineItemsFailure());
  },
  removeLineItem(lineItem) {
    return request({
      url: `/remove_item/${lineItem.id}`,
      method: 'DELETE',
      protectCSRF: true,
    })
    .then(() => Actions.removeLineItemSuccess(lineItem))
    .catch(() => Actions.removeLineItemFailure());
  },
};

export default createReducer({
  [Actions.open](state) {
    return state.set('isOpen', true);
  },
  [Actions.close](state) {
    return state.set('isOpen', false);
  },
  [Actions.toggle](state) {
    return state.set('isOpen', !state.get('isOpen'));
  },
  [Actions.loadLineItemsStart](state) {
    return loop(
      state.set('isLoading', true),
      Effects.promise(Api.loadLineItems)
    );
  },
  [Actions.loadLineItemsFailure](state) {
    return state
      .set('isLoading', false)
      .set('errorState', ErrorStates.LOADING);
  },
  [Actions.loadLineItemsSuccess](state, action) {
    return state
      .set('isLoading', false)
      .set('errorState', ErrorStates.NONE)
      .set('errorMessage', action.errorMessage || null)
      .set('lineItems', fromJS(action.lineItems));
  },
  [Actions.removeLineItemStart](state, lineItem) {
    return loop(
      state.set('isLoading', true),
      Effects.promise(Api.removeLineItem, lineItem)
    );
  },
  [Actions.removeLineItemSuccess](state) {
    return loop(
      state,
      Effects.constant(Actions.loadLineItemsStart())
    );
  },
  [Actions.removeLineItemFailure](state) {
    return state
      .set('isLoading', false)
      .set('errorState', ErrorStates.REMOVING);
  },
  [Actions.addLineItemFailure](state, brandName) {
    return state
      .set('errorState', ErrorStates.ADDING)
      .set('addFailureBrandName', brandName);
  },
}, initialState);



/** WEBPACK FOOTER **
 ** ./apps/storePages/cartDropdown/reducer.js
 **/